<template lang="pug">
  .scene(
    v-hammer:tap="click"
    v-hammer:panstart="onPanStart"
    v-hammer:pan="onPan"
    v-hammer:panend="onPanEnd"
    )
    .flip-card(
      :style="{ transform: `rotateY(${baseRotation + rotation}deg)`, transitionDuration: panning ? '0s' : `${(duration / 1000).toFixed(1)}s` }"
      )
      .card-face-front(
        :class="{ active: !flipped, hidden: panning && (!flipped && Math.abs(rotation) > 95 || flipped && Math.abs(rotation) < 85) }"
        )
        slot(name="front")
      .card-face-back(
        :class="{ active: flipped, hidden: panning && (!!flipped && Math.abs(rotation) > 95 || !flipped && Math.abs(rotation) < 85) }"
        )
        slot(name="back")
</template>

<script>
export default {
  name: 'FlipCard',
  props: {
    direction: String,
    disabled: Boolean
  },
  data() {
    return {
      fullSwipeLength: 0,
      defaultDirection: 'right',
      baseRotation: 0,
      rotation: 0,
      panning: false,
      duration: 500
    }
  },
  computed: {
    flipped() {
      return this.isFlipped();
    }
  },
  methods: {
    isFlipped() {
      return Math.abs(this.baseRotation % 360) === 180;
    },
    onPanStart({ target, preventDefault }) {
      if (this.disabled) {
        return;
      }
      preventDefault();
      this.fullSwipeLength = target.offsetWidth;
      this.rotation = 0;
      this.panning = true;
    },
    onPan({ deltaX, preventDefault }) {
      if (this.disabled) {
        return;
      }
      preventDefault();
      const width = this.fullSwipeLength;
      let rotation = deltaX / width * 180;
      console.log(width);
      rotation = Math.min(180, rotation);
      rotation = Math.max(-180, rotation);
      this.rotation = rotation;
    },
    onPanEnd({ preventDefault }) {
      if (this.disabled) {
        return;
      }
      preventDefault();
      const direction = this.rotation > 0 ? 1 : -1;
      if (Math.abs(this.rotation) > 90) {
        this.baseRotation += 180 * direction;
      }
      this.rotation = 0;
      setTimeout(() =>
        this.$emit('flip', {
          direction: direction > 0 ? 'left' : 'right',
          flipped: this.isFlipped()
        }),
        this.duration
      );
      this.panning = false;
    },
    click({ preventDefault }) {
      const direction = this.direction || this.defaultDirection;
      this.clicking = true;
      if (this.disabled) {
        return;
      }
      preventDefault();
      if (direction === 'left') {
        this.baseRotation += 180;
      } else {
        this.baseRotation -= 180;
      }
      setTimeout(() =>
        this.$emit('flip', {
          direction,
          flipped: this.isFlipped()
        }),
        this.duration
      );
      this.clicking = false;
    }
  }
}
</script>

<style scoped lang="stylus">

  .scene
    width 100%
    height 100%
    perspective 1000px
    transform-style preserve-3d

  .flip-card
    width 100%
    height 100%
    padding 0
    position relative
    transform-style preserve-3d
    transform rotateX(0deg) rotateY(0)
    transition-property transform

  .card-face-front, .card-face-back
    position absolute
    width 100%
    height 100%
    &.hidden
      display none
    & > div
      overflow initial
      transform-style preserve-3d
      width 100%
      height 100%
      backface-visibility hidden

  .card-face-back
    transform rotateX(0deg) rotateY(180deg) translate3d(0, 0, 1px)
  .card-face-front
    transform rotateX(0deg) rotateY(0deg) translate3d(0, 0, 0)
</style>
